const fetchConfig = async () => {
  let data = await window.fetch(
    `${process.env.REACT_APP_STARLINK_URL}/offer/config/${
      window.Shopify.shop
    }/conf.json`
  );
  data = await data.json();
  return data;
};

const calculateForeground = rgb => {
  // The code below takes a rgb string and converts into array of integers consisting the R, G, B values
  let rgbArray = rgb
    .substring(rgb.indexOf("(") + 1, rgb.length - 1)
    .split(",")
    .map(Number);
  // Based on the R, G, B values foreground color is calculated (either black or white)
  let foreground =
    rgbArray[0] * 0.299 + rgbArray[1] * 0.587 + rgbArray[2] * 0.114 > 186
      ? "black"
      : "white";
  return foreground;
};

const rgbToRgba = (rgb, alphaValue) => {
  // The code below takes a rgb string and converts into array of integers consisting the R, G, B values
  let rgbArray = rgb.substring(rgb.indexOf("(") + 1, rgb.length - 1).split(",");
  let bgColor = `rgba(${rgbArray[0]},${rgbArray[1]},${
    rgbArray[2]
  },${alphaValue})`;
  return bgColor;
};

const traceWidgetLoad = event => {
  if (window.isPreviewPage !== true) {
    window
      .fetch(`${process.env.ANALYTICS_TRACING_URL}/trace/events`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(event)
      })
      .catch(err => {
        console.warn(err);
      });
  }
};

module.exports = {
  rgbToRgba,
  calculateForeground,
  fetchConfig,
  traceWidgetLoad
};
